import { useTranslation } from "react-i18next";
import { CURRENT_ENV_STAGE, featureMaxStage, isHiddenOnProd, type EnvStage, type FeatureKey } from "../../features";

interface StageBadgeProps {
    // Entweder ein Feature-Flag (features.ts) ...
    feature?: FeatureKey;
    // ... oder direkt eine Grenze (z. B. appRegistry.ts maxStage / Kategorie).
    maxStage?: EnvStage;
    className?: string;
    // Nur ein Punkt statt Text - fuer enge Stellen wie die eingeklappte Sidebar (Icon-Leiste).
    compact?: boolean;
}

// Einheitliche Markierung fuer alles, was auf Prod NICHT erscheint (Apps, Kategorien, einzelne
// Funktionen hinter Feature-Flags). Rein abgeleitete Anzeige, nie Steuerung - die Sichtbarkeit
// selbst regeln weiterhin isFeatureEnabled()/isAppVisible(). Auf Prod rendert sie nie.
export const StageBadge = ({ feature, maxStage, className = 'ms-1', compact = false }: StageBadgeProps) => {
    const { t } = useTranslation('common');
    const limit = feature ? featureMaxStage(feature) : maxStage;
    if (CURRENT_ENV_STAGE === 'prod' || !isHiddenOnProd(limit)) return null;

    if (compact) {
        return (
            <span
                className={`position-absolute rounded-circle bg-warning ${className}`}
                style={{ width: 8, height: 8, top: 4, right: 4 }}
                title={`${limit} – ${t('stageBadge.title')}`}
                aria-label={`${limit} – ${t('stageBadge.title')}`}
            />
        );
    }

    return (
        <span
            className={`badge rounded-pill text-bg-warning align-middle ${className}`}
            style={{ fontSize: '0.6rem', fontWeight: 600, letterSpacing: '0.02em' }}
            title={t('stageBadge.title')}
        >
            {limit}
        </span>
    );
};
